import { computed, ref } from 'vue';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useModuleConfig } from '@rebuild/hooks/data/useModuleConfig';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import { useQuestionDisplayUtils } from '@rebuild/materials/shared/question/composables/useQuestionDisplayUtils';
import { resolvePageId } from '@rebuild/utils/context';

export const useSurfQuestion = () => {
	const { question } = useModuleData();
	const { config, loadModuleConfig } = useModuleConfig();
	const { viewModule } = useModuleNavigation();
	const { getQuestionTimeText } = useQuestionDisplayUtils();

	// 数据
	const questionData = computed(() => {
		return question.data?.rows || [];
	});

	// 初始化配置和Tabs
	const initConfig = async () => {
		await loadModuleConfig('question');
	};
	const questionTypeRange = computed(() => {
		const tabs = config.value?.tab || [];
		return tabs
			.filter(tab => tab.isPublish)
			.map(tab => {
				const parseValue = item => {
					// 特殊：全部
					if (item.id === 'question_all') return '';
					return item.value;
				};
				const tabId = parseValue(tab);
				return {
					...tab,
					tabId,
					label: tab.name
				};
			});
	});

	// 加载数据
	const loadQuestionData = async (params = {}) => {
		const options = {
			pagestart: params.pagestart,
			pagenum: params.pagenum,
			keyword: params.keyword || '',
			pageId: resolvePageId()
		};
		if (params.sourceBiz) options.sourceBiz = params.sourceBiz;
		await question.refresh(options);
	};

	const activeType = ref('');
	// 切换分类
	const handleTabChange = tabValue => {
		activeType.value = tabValue;
	};

	// 预览详情
	const handlePreview = item => {
		viewModule('question', item);
	};

	// 是否为空
	const isEmpty = computed(() => {
		return question.empty || !questionData.value.length;
	});

	const formatForHeader = item => {
		const values = [];
		if (item.questionTime) values.push(getQuestionTimeText(item));
		if (item.sourceDesc) values.push(item.sourceDesc);
		return values.join(' | ');
	};

	return {
		question,
		questionTypeRange,
		activeType,
		questionData,
		initConfig,
		loadQuestionData,
		handleTabChange,
		handlePreview,
		isEmpty,
		formatForHeader
	};
};
